
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {RequestDirection} from '../core/RequestDirection';
import {FieldModelRequestDirection} from '../core/RequestDirection';
import {TransactionType} from '../entity/TransactionType';
import {FieldModelTransactionType} from '../entity/TransactionType';
import {OrderType} from '../core/OrderType';
import {FieldModelOrderType} from '../core/OrderType';

/**
 * TradeHistoryParams struct
 */
class TradeHistoryParams {
  /**
   * Initialize struct
   * @param {!RequestDirection=} requestDirection
   * @param {Date=} requestFrom
   * @param {Date=} requestTo
   * @param {number=} lastRecordId
   * @param {!number=} pageSize
   * @param {!Set=} accountLogins
   * @param {number=} managerLogin
   * @param {number=} orderId
   * @param {UUID=} platformId
   * @param {!boolean=} filterAccountGroups
   * @param {!Set=} accountGroup
   * @param {!boolean=} filterSymbols
   * @param {!Set=} symbols
   * @param {!boolean=} filterTransactionTypes
   * @param {!Set=} transactionTypes
   * @param {!boolean=} filterOrderTypes
   * @param {!Set=} orderTypes
   * @param {!boolean=} latestOrderState
   * @param {!boolean=} readFromArchive
   * @constructor
   */
  constructor (requestDirection = new RequestDirection(RequestDirection.FORWARD), requestFrom = null, requestTo = null, lastRecordId = null, pageSize = 1000, accountLogins = new Set(), managerLogin = null, orderId = null, platformId = null, filterAccountGroups = false, accountGroup = new Set(), filterSymbols = false, symbols = new Set(), filterTransactionTypes = false, transactionTypes = new Set(), filterOrderTypes = false, orderTypes = new Set(), latestOrderState = false, readFromArchive = false) {
    this.RequestDirection = requestDirection
    this.RequestFrom = requestFrom
    this.RequestTo = requestTo
    this.LastRecordId = lastRecordId
    this.PageSize = pageSize
    this.AccountLogins = accountLogins
    this.ManagerLogin = managerLogin
    this.OrderId = orderId
    this.PlatformId = platformId
    this.FilterAccountGroups = filterAccountGroups
    this.AccountGroup = accountGroup
    this.FilterSymbols = filterSymbols
    this.Symbols = symbols
    this.FilterTransactionTypes = filterTransactionTypes
    this.TransactionTypes = transactionTypes
    this.FilterOrderTypes = filterOrderTypes
    this.OrderTypes = orderTypes
    this.LatestOrderState = latestOrderState
    this.ReadFromArchive = readFromArchive
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradeHistoryParams}
   * @param {!TradeHistoryParams} other Other struct
   * @returns {!TradeHistoryParams} This struct
   */
  copy (other) {
    if (other.RequestDirection != null) {
      this.RequestDirection = RequestDirection.fromObject(other.RequestDirection)
    } else {
      this.RequestDirection = null
    }
    if (other.RequestFrom != null) {
      if (other.RequestFrom instanceof Date) {
        this.RequestFrom = new Date(other.RequestFrom.getTime())
      } else {
        this.RequestFrom = new Date(Math.round(other.RequestFrom / 1000000))
      }
    } else {
      this.RequestFrom = null
    }
    if (other.RequestTo != null) {
      if (other.RequestTo instanceof Date) {
        this.RequestTo = new Date(other.RequestTo.getTime())
      } else {
        this.RequestTo = new Date(Math.round(other.RequestTo / 1000000))
      }
    } else {
      this.RequestTo = null
    }
    if (other.LastRecordId != null) {
      this.LastRecordId = UInt64.fromNumber(other.LastRecordId)
    } else {
      this.LastRecordId = null
    }
    if (other.PageSize != null) {
      this.PageSize = other.PageSize
    } else {
      this.PageSize = null
    }
    if (other.AccountLogins != null) {
      this.AccountLogins = new Set()
      for (let item of other.AccountLogins) {
        if (item != null) {
          let tempItem
          tempItem = UInt64.fromNumber(item)
          this.AccountLogins.add(tempItem)
        } else {
          this.AccountLogins.add(null)
        }
      }
    } else {
      this.AccountLogins = null
    }
    if (other.ManagerLogin != null) {
      this.ManagerLogin = UInt64.fromNumber(other.ManagerLogin)
    } else {
      this.ManagerLogin = null
    }
    if (other.OrderId != null) {
      this.OrderId = UInt64.fromNumber(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.PlatformId != null) {
      this.PlatformId = new UUID(other.PlatformId)
    } else {
      this.PlatformId = null
    }
    if (other.FilterAccountGroups != null) {
      this.FilterAccountGroups = other.FilterAccountGroups
    } else {
      this.FilterAccountGroups = null
    }
    if (other.AccountGroup != null) {
      this.AccountGroup = new Set()
      for (let item of other.AccountGroup) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.AccountGroup.add(tempItem)
        } else {
          this.AccountGroup.add(null)
        }
      }
    } else {
      this.AccountGroup = null
    }
    if (other.FilterSymbols != null) {
      this.FilterSymbols = other.FilterSymbols
    } else {
      this.FilterSymbols = null
    }
    if (other.Symbols != null) {
      this.Symbols = new Set()
      for (let item of other.Symbols) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.Symbols.add(tempItem)
        } else {
          this.Symbols.add(null)
        }
      }
    } else {
      this.Symbols = null
    }
    if (other.FilterTransactionTypes != null) {
      this.FilterTransactionTypes = other.FilterTransactionTypes
    } else {
      this.FilterTransactionTypes = null
    }
    if (other.TransactionTypes != null) {
      this.TransactionTypes = new Set()
      for (let item of other.TransactionTypes) {
        if (item != null) {
          let tempItem
          tempItem = TransactionType.fromObject(item)
          this.TransactionTypes.add(tempItem)
        } else {
          this.TransactionTypes.add(null)
        }
      }
    } else {
      this.TransactionTypes = null
    }
    if (other.FilterOrderTypes != null) {
      this.FilterOrderTypes = other.FilterOrderTypes
    } else {
      this.FilterOrderTypes = null
    }
    if (other.OrderTypes != null) {
      this.OrderTypes = new Set()
      for (let item of other.OrderTypes) {
        if (item != null) {
          let tempItem
          tempItem = OrderType.fromObject(item)
          this.OrderTypes.add(tempItem)
        } else {
          this.OrderTypes.add(null)
        }
      }
    } else {
      this.OrderTypes = null
    }
    if (other.LatestOrderState != null) {
      this.LatestOrderState = other.LatestOrderState
    } else {
      this.LatestOrderState = null
    }
    if (other.ReadFromArchive != null) {
      this.ReadFromArchive = other.ReadFromArchive
    } else {
      this.ReadFromArchive = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradeHistoryParams}
   * @returns {!TradeHistoryParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradeHistoryParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradeHistoryParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradeHistoryParams}
   * @param {!TradeHistoryParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradeHistoryParams)) {
      throw new TypeError('Instance of TradeHistoryParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradeHistoryParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      RequestDirection: ((this.RequestDirection != null) ? this.RequestDirection : null),
      RequestFrom: ((this.RequestFrom != null) ? (this.RequestFrom.getTime() * 1000000) : null),
      RequestTo: ((this.RequestTo != null) ? (this.RequestTo.getTime() * 1000000) : null),
      LastRecordId: ((this.LastRecordId != null) ? this.LastRecordId.toNumber() : null),
      PageSize: ((this.PageSize != null) ? this.PageSize : null),
      AccountLogins: ((this.AccountLogins != null) ? Array.from(this.AccountLogins, item => ((item != null) ? item.toNumber() : null)) : null),
      ManagerLogin: ((this.ManagerLogin != null) ? this.ManagerLogin.toNumber() : null),
      OrderId: ((this.OrderId != null) ? this.OrderId.toNumber() : null),
      PlatformId: ((this.PlatformId != null) ? this.PlatformId.toString() : null),
      FilterAccountGroups: ((this.FilterAccountGroups != null) ? this.FilterAccountGroups : null),
      AccountGroup: ((this.AccountGroup != null) ? Array.from(this.AccountGroup, item => ((item != null) ? item.toString() : null)) : null),
      FilterSymbols: ((this.FilterSymbols != null) ? this.FilterSymbols : null),
      Symbols: ((this.Symbols != null) ? Array.from(this.Symbols, item => ((item != null) ? item.toString() : null)) : null),
      FilterTransactionTypes: ((this.FilterTransactionTypes != null) ? this.FilterTransactionTypes : null),
      TransactionTypes: ((this.TransactionTypes != null) ? Array.from(this.TransactionTypes, item => ((item != null) ? item : null)) : null),
      FilterOrderTypes: ((this.FilterOrderTypes != null) ? this.FilterOrderTypes : null),
      OrderTypes: ((this.OrderTypes != null) ? Array.from(this.OrderTypes, item => ((item != null) ? item : null)) : null),
      LatestOrderState: ((this.LatestOrderState != null) ? this.LatestOrderState : null),
      ReadFromArchive: ((this.ReadFromArchive != null) ? this.ReadFromArchive : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradeHistoryParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradeHistoryParams} other Object value
   * @returns {!TradeHistoryParams} Created struct
   */
  static fromObject (other) {
    return new TradeHistoryParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradeHistoryParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradeHistoryParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradeHistoryParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 10028
  }
}

export { TradeHistoryParams };

/**
 * Fast Binary Encoding TradeHistoryParams field model
 */
class FieldModelTradeHistoryParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.RequestDirection = new FieldModelRequestDirection(buffer, 4 + 4)
    this.RequestFrom = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.RequestDirection.fbeOffset + this.RequestDirection.fbeSize), buffer, this.RequestDirection.fbeOffset + this.RequestDirection.fbeSize)
    this.RequestTo = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.RequestFrom.fbeOffset + this.RequestFrom.fbeSize), buffer, this.RequestFrom.fbeOffset + this.RequestFrom.fbeSize)
    this.LastRecordId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize), buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize)
    this.PageSize = new fbe.FieldModelUInt32(buffer, this.LastRecordId.fbeOffset + this.LastRecordId.fbeSize)
    this.AccountLogins = new fbe.FieldModelSet(new fbe.FieldModelUInt64(buffer, this.PageSize.fbeOffset + this.PageSize.fbeSize), buffer, this.PageSize.fbeOffset + this.PageSize.fbeSize)
    this.ManagerLogin = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.AccountLogins.fbeOffset + this.AccountLogins.fbeSize), buffer, this.AccountLogins.fbeOffset + this.AccountLogins.fbeSize)
    this.OrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.ManagerLogin.fbeOffset + this.ManagerLogin.fbeSize), buffer, this.ManagerLogin.fbeOffset + this.ManagerLogin.fbeSize)
    this.PlatformId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize), buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.FilterAccountGroups = new fbe.FieldModelBool(buffer, this.PlatformId.fbeOffset + this.PlatformId.fbeSize)
    this.AccountGroup = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this.FilterAccountGroups.fbeOffset + this.FilterAccountGroups.fbeSize), buffer, this.FilterAccountGroups.fbeOffset + this.FilterAccountGroups.fbeSize)
    this.FilterSymbols = new fbe.FieldModelBool(buffer, this.AccountGroup.fbeOffset + this.AccountGroup.fbeSize)
    this.Symbols = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this.FilterSymbols.fbeOffset + this.FilterSymbols.fbeSize), buffer, this.FilterSymbols.fbeOffset + this.FilterSymbols.fbeSize)
    this.FilterTransactionTypes = new fbe.FieldModelBool(buffer, this.Symbols.fbeOffset + this.Symbols.fbeSize)
    this.TransactionTypes = new fbe.FieldModelSet(new FieldModelTransactionType(buffer, this.FilterTransactionTypes.fbeOffset + this.FilterTransactionTypes.fbeSize), buffer, this.FilterTransactionTypes.fbeOffset + this.FilterTransactionTypes.fbeSize)
    this.FilterOrderTypes = new fbe.FieldModelBool(buffer, this.TransactionTypes.fbeOffset + this.TransactionTypes.fbeSize)
    this.OrderTypes = new fbe.FieldModelSet(new FieldModelOrderType(buffer, this.FilterOrderTypes.fbeOffset + this.FilterOrderTypes.fbeSize), buffer, this.FilterOrderTypes.fbeOffset + this.FilterOrderTypes.fbeSize)
    this.LatestOrderState = new fbe.FieldModelBool(buffer, this.OrderTypes.fbeOffset + this.OrderTypes.fbeSize)
    this.ReadFromArchive = new fbe.FieldModelBool(buffer, this.LatestOrderState.fbeOffset + this.LatestOrderState.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelTradeHistoryParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradeHistoryParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.RequestDirection.fbeSize + this.RequestFrom.fbeSize + this.RequestTo.fbeSize + this.LastRecordId.fbeSize + this.PageSize.fbeSize + this.AccountLogins.fbeSize + this.ManagerLogin.fbeSize + this.OrderId.fbeSize + this.PlatformId.fbeSize + this.FilterAccountGroups.fbeSize + this.AccountGroup.fbeSize + this.FilterSymbols.fbeSize + this.Symbols.fbeSize + this.FilterTransactionTypes.fbeSize + this.TransactionTypes.fbeSize + this.FilterOrderTypes.fbeSize + this.OrderTypes.fbeSize + this.LatestOrderState.fbeSize + this.ReadFromArchive.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradeHistoryParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.RequestDirection.fbeExtra + this.RequestFrom.fbeExtra + this.RequestTo.fbeExtra + this.LastRecordId.fbeExtra + this.PageSize.fbeExtra + this.AccountLogins.fbeExtra + this.ManagerLogin.fbeExtra + this.OrderId.fbeExtra + this.PlatformId.fbeExtra + this.FilterAccountGroups.fbeExtra + this.AccountGroup.fbeExtra + this.FilterSymbols.fbeExtra + this.Symbols.fbeExtra + this.FilterTransactionTypes.fbeExtra + this.TransactionTypes.fbeExtra + this.FilterOrderTypes.fbeExtra + this.OrderTypes.fbeExtra + this.LatestOrderState.fbeExtra + this.ReadFromArchive.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradeHistoryParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradeHistoryParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradeHistoryParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 10028
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradeHistoryParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradeHistoryParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.RequestDirection.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestDirection.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestDirection.fbeSize

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestFrom.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestTo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastRecordId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PageSize.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.AccountLogins.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountLogins.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountLogins.fbeSize

    if ((fbeCurrentSize + this.ManagerLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerLogin.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PlatformId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.FilterAccountGroups.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FilterAccountGroups.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterAccountGroups.fbeSize

    if ((fbeCurrentSize + this.AccountGroup.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroup.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroup.fbeSize

    if ((fbeCurrentSize + this.FilterSymbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FilterSymbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterSymbols.fbeSize

    if ((fbeCurrentSize + this.Symbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    if ((fbeCurrentSize + this.FilterTransactionTypes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FilterTransactionTypes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterTransactionTypes.fbeSize

    if ((fbeCurrentSize + this.TransactionTypes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionTypes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTypes.fbeSize

    if ((fbeCurrentSize + this.FilterOrderTypes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FilterOrderTypes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterOrderTypes.fbeSize

    if ((fbeCurrentSize + this.OrderTypes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderTypes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTypes.fbeSize

    if ((fbeCurrentSize + this.LatestOrderState.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LatestOrderState.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestOrderState.fbeSize

    if ((fbeCurrentSize + this.ReadFromArchive.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ReadFromArchive.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReadFromArchive.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradeHistoryParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradeHistoryParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradeHistoryParams}
   * @param {!TradeHistoryParams} fbeValue Default value, defaults is new TradeHistoryParams()
   * @returns {!TradeHistoryParams} TradeHistoryParams value
   */
  get (fbeValue = new TradeHistoryParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradeHistoryParams}
   * @param {!TradeHistoryParams} fbeValue TradeHistoryParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.RequestDirection.fbeSize) <= fbeStructSize) {
      fbeValue.RequestDirection = this.RequestDirection.get(new RequestDirection(RequestDirection.FORWARD))
    } else {
      fbeValue.RequestDirection = new RequestDirection(RequestDirection.FORWARD)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestDirection.fbeSize

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) <= fbeStructSize) {
      fbeValue.RequestFrom = this.RequestFrom.get()
    } else {
      fbeValue.RequestFrom = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) <= fbeStructSize) {
      fbeValue.RequestTo = this.RequestTo.get()
    } else {
      fbeValue.RequestTo = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) <= fbeStructSize) {
      fbeValue.LastRecordId = this.LastRecordId.get()
    } else {
      fbeValue.LastRecordId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) <= fbeStructSize) {
      fbeValue.PageSize = this.PageSize.get(1000)
    } else {
      fbeValue.PageSize = 1000
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.AccountLogins.fbeSize) <= fbeStructSize) {
      this.AccountLogins.get(fbeValue.AccountLogins)
    } else {
      fbeValue.AccountLogins.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountLogins.fbeSize

    if ((fbeCurrentSize + this.ManagerLogin.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerLogin = this.ManagerLogin.get()
    } else {
      fbeValue.ManagerLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerLogin.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) <= fbeStructSize) {
      fbeValue.PlatformId = this.PlatformId.get()
    } else {
      fbeValue.PlatformId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.FilterAccountGroups.fbeSize) <= fbeStructSize) {
      fbeValue.FilterAccountGroups = this.FilterAccountGroups.get(false)
    } else {
      fbeValue.FilterAccountGroups = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterAccountGroups.fbeSize

    if ((fbeCurrentSize + this.AccountGroup.fbeSize) <= fbeStructSize) {
      this.AccountGroup.get(fbeValue.AccountGroup)
    } else {
      fbeValue.AccountGroup.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroup.fbeSize

    if ((fbeCurrentSize + this.FilterSymbols.fbeSize) <= fbeStructSize) {
      fbeValue.FilterSymbols = this.FilterSymbols.get(false)
    } else {
      fbeValue.FilterSymbols = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterSymbols.fbeSize

    if ((fbeCurrentSize + this.Symbols.fbeSize) <= fbeStructSize) {
      this.Symbols.get(fbeValue.Symbols)
    } else {
      fbeValue.Symbols.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    if ((fbeCurrentSize + this.FilterTransactionTypes.fbeSize) <= fbeStructSize) {
      fbeValue.FilterTransactionTypes = this.FilterTransactionTypes.get(false)
    } else {
      fbeValue.FilterTransactionTypes = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterTransactionTypes.fbeSize

    if ((fbeCurrentSize + this.TransactionTypes.fbeSize) <= fbeStructSize) {
      this.TransactionTypes.get(fbeValue.TransactionTypes)
    } else {
      fbeValue.TransactionTypes.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTypes.fbeSize

    if ((fbeCurrentSize + this.FilterOrderTypes.fbeSize) <= fbeStructSize) {
      fbeValue.FilterOrderTypes = this.FilterOrderTypes.get(false)
    } else {
      fbeValue.FilterOrderTypes = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterOrderTypes.fbeSize

    if ((fbeCurrentSize + this.OrderTypes.fbeSize) <= fbeStructSize) {
      this.OrderTypes.get(fbeValue.OrderTypes)
    } else {
      fbeValue.OrderTypes.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTypes.fbeSize

    if ((fbeCurrentSize + this.LatestOrderState.fbeSize) <= fbeStructSize) {
      fbeValue.LatestOrderState = this.LatestOrderState.get(false)
    } else {
      fbeValue.LatestOrderState = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestOrderState.fbeSize

    if ((fbeCurrentSize + this.ReadFromArchive.fbeSize) <= fbeStructSize) {
      fbeValue.ReadFromArchive = this.ReadFromArchive.get(false)
    } else {
      fbeValue.ReadFromArchive = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReadFromArchive.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradeHistoryParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradeHistoryParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradeHistoryParams}
   * @param {!TradeHistoryParams} fbeValue TradeHistoryParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradeHistoryParams}
   * @param {TradeHistoryParams} fbeValue TradeHistoryParams value
   */
  setFields (fbeValue) {
    this.RequestDirection.set(fbeValue.RequestDirection)
    this.RequestFrom.set(fbeValue.RequestFrom)
    this.RequestTo.set(fbeValue.RequestTo)
    this.LastRecordId.set(fbeValue.LastRecordId)
    this.PageSize.set(fbeValue.PageSize)
    this.AccountLogins.set(fbeValue.AccountLogins)
    this.ManagerLogin.set(fbeValue.ManagerLogin)
    this.OrderId.set(fbeValue.OrderId)
    this.PlatformId.set(fbeValue.PlatformId)
    this.FilterAccountGroups.set(fbeValue.FilterAccountGroups)
    this.AccountGroup.set(fbeValue.AccountGroup)
    this.FilterSymbols.set(fbeValue.FilterSymbols)
    this.Symbols.set(fbeValue.Symbols)
    this.FilterTransactionTypes.set(fbeValue.FilterTransactionTypes)
    this.TransactionTypes.set(fbeValue.TransactionTypes)
    this.FilterOrderTypes.set(fbeValue.FilterOrderTypes)
    this.OrderTypes.set(fbeValue.OrderTypes)
    this.LatestOrderState.set(fbeValue.LatestOrderState)
    this.ReadFromArchive.set(fbeValue.ReadFromArchive)
  }
}

export { FieldModelTradeHistoryParams };

/**
 * Fast Binary Encoding TradeHistoryParams model
 */
class TradeHistoryParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradeHistoryParams(this.buffer, 4)
  }

  /**
   * Get the TradeHistoryParams model
   * @this {!TradeHistoryParamsModel}
   * @returns {!FieldModelTradeHistoryParams} model TradeHistoryParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradeHistoryParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradeHistoryParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradeHistoryParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradeHistoryParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradeHistoryParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradeHistoryParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradeHistoryParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradeHistoryParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradeHistoryParamsModel}
   * @param {!TradeHistoryParams} value TradeHistoryParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradeHistoryParamsModel}
   * @param {!TradeHistoryParams} value TradeHistoryParams value, defaults is new TradeHistoryParams()
   * @return {!object} Deserialized TradeHistoryParams value and its size
   */
  deserialize (value = new TradeHistoryParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradeHistoryParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradeHistoryParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradeHistoryParamsModel}
   * @param {!number} prev Previous TradeHistoryParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradeHistoryParamsModel };
